// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"c1dc53c0","297":"789c44e9","643":"b366c22a"}[chunkId] + ".chunk.js";
};